module.exports = __webpack_public_path__ + "media/images/icons/da_assegnare_simulazione-74d5c015877003b8b719962192181037.svg";